<template>
	<div v-for="room in items" :key="room.pageID" class="row contentblock">
		<div class="columns column6 contentblock-content">
			<h2>{{ room.header }}</h2>
			<div v-parse-links v-html="room.overviewContent" />
			<slot
				name="extra-content"
				:facilities="room.facilities"
				:filename="localePath(`/${room.filename}`)"
				:bookingid="room.bookingID"
			/>
		</div>
		<div class="contentblock-image">
			<picture>
				<source v-if="room.imageOverviewWebp" :srcset="room.imageOverviewWebp" type="image/webp" />
				<source :srcset="room.imageOverview" />
				<img loading="lazy" :src="room.imageOverview" :alt="room.imageOverviewAlt" />
			</picture>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--contentblock-background-color);
}

.contentblock {
	margin: 80px auto;
	position: relative;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	gap: 100px;

	&:nth-child(even) {
		flex-flow: row-reverse nowrap;
	}
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	width: 78%;
	z-index: 1;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border: 2px solid #000;
	}
}

.contentblock-content {
	padding: 0 40px;
	margin: 0 auto;
	position: relative;
	z-index: 2;
}

@media (max-width: 1280px) {
	.contentblock {
		gap: 30px;
		padding: 0 20px;
	}

	.contentblock-image {
		width: 55%;
	}

	.contentblock-content {
		padding: 0 20px;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse !important;
		margin: 0 auto;
	}

	.contentblock-content {
		margin: 0 auto;
		padding: 30px 0;
	}
}
</style>
